import { render, staticRenderFns } from "./lunbo.vue?vue&type=template&id=82af5aa6&scoped=true"
import script from "./lunbo.vue?vue&type=script&lang=js"
export * from "./lunbo.vue?vue&type=script&lang=js"
import style0 from "./lunbo.vue?vue&type=style&index=0&id=82af5aa6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82af5aa6",
  null
  
)

export default component.exports